import "core-js/modules/es6.symbol.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import every from 'lodash/every';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
import { validateEmail } from '~/helpers/validation-helper';
import { createLotteryTicket } from '~/services/lottery';
import MdmSelect from '~/components/atoms/MdmSelect.vue';
import MdmCheckbox from '~/components/atoms/MdmCheckbox.vue';
import SubtitlePage from '~/components/atoms/Editorial/SubtitlePage.vue';
import TextField from '~/components/atoms/TextField.vue';
import MdmLink from '~/components/atoms/MdmLink.vue';

var GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

var GlobalTitle = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalTitle.vue');

var MANDATORY_FIELDS = ['firstName', 'lastName', 'address', 'email', 'city', 'zipcode'];
export default {
  name: 'LotteryForm',
  components: {
    GlobalRichText,
    GlobalTitle,
    MdmSelect,
    MdmCheckbox,
    SubtitlePage,
    TextField,
    MdmLink
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      pendingRequest: false,
      formSuccess: false,
      showServerError: false,
      submitted: false,
      values: {
        question: '',
        civility: 'mr',
        firstName: '',
        lastName: '',
        address: '',
        additionalAddress: '',
        zipcode: '',
        city: '',
        email: '',
        phone: '',
        optinDefault: false,
        optinPartner: false
      },
      errors: {
        question: false,
        firstName: false,
        lastName: false,
        address: false,
        zipcode: false,
        city: false,
        email: false,
        emailFormat: false
      }
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    questionIsRequiredLegally() {
      return this.locale.market === 'BE';
    },

    lotteryId() {
      var {
        gameId
      } = this.$store.state.sharedEnv.payload;
      return this.payload.primary[gameId];
    },

    title() {
      return this.payload.primary.title[0] || {};
    },

    subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },

    paragraph() {
      return this.payload.primary.description || [];
    },

    confirmationParagraph() {
      return this.payload.primary.confirmation_text || [];
    },

    civility() {
      return "".concat(this.$t('civility'));
    },

    civilities() {
      return [{
        name: 'mr',
        label: this.$t('mr')
      }, {
        name: 'mrs',
        label: this.$t('mrs')
      }];
    },

    image() {
      return {
        small: formatPrismicImage(this.payload.primary.image.small.url, ['w_375']) || EMPTY_PIXEL,
        medium: formatPrismicImage(this.payload.primary.image.medium.url, ['w_1024']) || EMPTY_PIXEL,
        large: formatPrismicImage(this.payload.primary.image.large.url, ['w_1440']) || EMPTY_PIXEL
      };
    },

    imageCta() {
      return {
        small: formatPrismicImage(this.payload.primary.confirmation_image.small.url, ['w_375']) || EMPTY_PIXEL,
        medium: formatPrismicImage(this.payload.primary.confirmation_image.medium.url, ['w_1024']) || EMPTY_PIXEL,
        large: formatPrismicImage(this.payload.primary.confirmation_image.large.url, ['w_1440']) || EMPTY_PIXEL
      };
    },

    questionLabel() {
      return "".concat(this.$t('question'), "*");
    },

    firstNameLabel() {
      return "".concat(this.$t('firstName'), "*");
    },

    lastNameLabel() {
      return "".concat(this.$t('lastName'), "*");
    },

    addressLabel() {
      return "".concat(this.$t('address'), "*");
    },

    additionalAddressLabel() {
      return "".concat(this.$t('additionalAddress'));
    },

    zipcodeLabel() {
      return "".concat(this.$t('zipcode'), "*");
    },

    cityLabel() {
      return "".concat(this.$t('city'), "*");
    },

    phoneLabel() {
      return "".concat(this.$t('phone'));
    },

    emailLabel() {
      return "".concat(this.$t('email'), "*");
    },

    optinDefaultLabel() {
      return this.payload.primary.optin_1 || [];
    },

    optinPartnerLabel() {
      return this.payload.primary.optin_2 || [];
    },

    ctaText() {
      return "".concat(this.$t('ctaText'));
    },

    serverErrorMessage() {
      return [];
    },

    mandatoryFieldsLabel() {
      return "* ".concat(this.$t('mendatoryFields'));
    },

    mention() {
      return this.payload.primary.mention || [];
    },

    confirmationLink() {
      return this.payload.primary.confirmation_link.url || '/';
    },

    emailErrorMessage() {
      return this.errors.emailFormat ? this.payload.primary.field_email_invalid_error : '';
    },

    eventLabel() {
      if (this.values.optinDefault) return 'Optin_mdm';
      if (this.values.optinPartner) return 'Optin_blooms';
      if (this.values.optinDefault && this.values.optinPartner) return 'Optin_all';
      return 'Optout_all';
    },

    tracking() {
      return {
        data: {
          event_category: 'Jeux concours',
          event_action: 'Inscription',
          event_label: this.eventLabel
        }
      };
    },

    trackingCta() {
      return {
        data: {
          event_category: 'Jeux concours',
          event_action: 'Clic_CTA',
          event_label: this.eventLabel
        }
      };
    }

  }),
  watch: {
    values: {
      handler() {
        if (!this.submitted) {
          return;
        }

        this.validateMandatoryFields();
      },

      deep: true
    },
    'values.email': function watchEmail() {
      this.errors.emailFormat = false;
    }
  },
  methods: {
    onSubmit(event) {
      this.submitted = true;
      this.validateMandatoryFields();
      this.validateEmail();

      if (every(this.errors, field => !field)) {
        this.pendingRequest = true;
        createLotteryTicket(this.$store, this.lotteryId, this.values).then(status => {
          if (status) {
            this.formSuccess = true;
            this.$root.$emit('generic-tracking', event, this.tracking);
            window.scrollTo(0, 0);
          } else {
            this.showServerError = true;
          }
        }).catch(err => {
          this.$logger.error(err);
          this.showServerError = true;
        }).finally(() => {
          this.pendingRequest = false;
        });
      }
    },

    validateMandatoryFields() {
      MANDATORY_FIELDS.forEach(field => {
        this.errors[field] = !this.values[field];
      });
    },

    validateEmail() {
      this.errors.emailFormat = this.values.email ? !validateEmail(this.values.email) : false; // Do not display format error if the field is empty
    }

  }
};